import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetDisplayOptionsClassesGraphQL } from '~/composables/useGetDisplayOptionsClassesGraphQL';
import { useGetComponentName } from '~/composables/useGetComponentName';
import useProductContent from '~/composables/useProductContent/useProductContent';
import { useParseDocumentToHtml } from '~/composables/useParseDocumentToHtml';
import NativeCarousel from '~/components/Molecules/NativeCarousel.vue';
import ItemImageTextStandardGraphql from '~/components/Organisms/ItemImageTextStandardGraphql.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockCardListGraphql',
  props: {
    title: null,
    cardsCollection: {
      default: function _default() {
        return {
          items: []
        };
      }
    },
    catchphrase: null,
    tabTitle: null,
    isContentExpanded: {
      type: Boolean
    },
    displayOptionsCollection: {
      default: function _default() {
        return {
          items: []
        };
      }
    },
    isHomePage: {
      type: Boolean
    },
    isInExpandableTab: {
      type: Boolean
    },
    isInTabContainer: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var ItemImageTextTwoGraphql = function ItemImageTextTwoGraphql() {
      return import('~/components/Organisms/ItemImageTextTwoGraphql.vue');
    };
    var _useProductContent = useProductContent(),
      mapGraphQLComponentName = _useProductContent.mapGraphQLComponentName;
    var cards = computed(function () {
      var _props$cardsCollectio;
      return ((_props$cardsCollectio = props.cardsCollection) === null || _props$cardsCollectio === void 0 ? void 0 : _props$cardsCollectio.items) || [];
    });
    var displayOptions = computed(function () {
      var _props$displayOptions;
      return ((_props$displayOptions = props.displayOptionsCollection) === null || _props$displayOptions === void 0 ? void 0 : _props$displayOptions.items) || [];
    });
    var cardsComponents = computed(function () {
      return mapGraphQLComponentName(cards.value).filter(function (card) {
        // Apply filter only for ItemImageText component type
        if ((card === null || card === void 0 ? void 0 : card.component) != 'ItemImageTextGraphql') return true;

        // ItemImageText need to have title or text to be displayed (just image is not enough)
        return (card === null || card === void 0 ? void 0 : card.title) || (card === null || card === void 0 ? void 0 : card.text);
      });
    });
    var componentName = computed(function () {
      return useGetComponentName({
        standard: ItemImageTextStandardGraphql,
        two: ItemImageTextTwoGraphql
      }, displayOptions.value);
    });
    var classes = computed(function () {
      return useGetDisplayOptionsClassesGraphQL(displayOptions.value);
    });
    var _useParseDocumentToHt = useParseDocumentToHtml(props.catchphrase),
      parsedCatchphrase = _useParseDocumentToHt.html;
    var carouselKey = computed(function () {
      return props.isContentExpanded + props.title;
    });
    return {
      __sfc: true,
      ItemImageTextTwoGraphql: ItemImageTextTwoGraphql,
      props: props,
      mapGraphQLComponentName: mapGraphQLComponentName,
      cards: cards,
      displayOptions: displayOptions,
      cardsComponents: cardsComponents,
      componentName: componentName,
      classes: classes,
      parsedCatchphrase: parsedCatchphrase,
      carouselKey: carouselKey,
      NativeCarousel: NativeCarousel
    };
  }
});